/* eslint-disable */
import Chart from 'react-apexcharts';

interface Props {
  data: {
    x: string;
    y: number;
  }[];
  options: any;
  name: string;
  height: string;
}

const ColumnChart = ({ data, options, name, height }: Props) => {
  const series = [{ name, data }];
  return (
    <Chart
      options={options}
      series={series}
      type="bar"
      className="w-full"
      height={height}
    />
  );
};

export default ColumnChart;
